// src/hooks/useSeo.js
// Gère <title> + meta description/keywords + Open Graph + Twitter + canonical + JSON-LD
// (sans dépendance externe). Maxula
import { useEffect } from 'react';

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setCanonical(href) {
  if (!href) return;
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) { el = document.createElement('link'); el.setAttribute('rel', 'canonical'); document.head.appendChild(el); }
  el.setAttribute('href', href);
}

function setJsonLd(json) {
  const existing = document.head.querySelector('script[data-seo-jsonld]');
  if (!json) { if (existing) existing.remove(); return; }
  let el = existing;
  if (!el) {
    el = document.createElement('script');
    el.setAttribute('type', 'application/ld+json');
    el.setAttribute('data-seo-jsonld', '1');
    document.head.appendChild(el);
  }
  el.textContent = json;
}

/**
 * useSeo({ title, description, keywords, image, canonical, url, type, jsonLd })
 *   url    : og:url (URL courante par défaut)
 *   type   : og:type ('website' par défaut ; 'product' pour un deal)
 *   jsonLd : objet schema.org injecté en <script type="application/ld+json">
 */
export default function useSeo({ title, description, keywords, image, canonical, url, type, jsonLd } = {}) {
  let ld = '';
  try { ld = jsonLd ? JSON.stringify(jsonLd) : ''; } catch (e) { ld = ''; }
  useEffect(() => {
    const href = url || canonical || (typeof window !== 'undefined' ? window.location.href : '');
    if (title) document.title = title;
    setMeta('name', 'description', description);
    setMeta('name', 'keywords', keywords);
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:type', type || 'website');
    setMeta('property', 'og:site_name', 'Maxula');
    if (href) setMeta('property', 'og:url', href);
    if (image) setMeta('property', 'og:image', image);
    setMeta('name', 'twitter:card', image ? 'summary_large_image' : 'summary');
    setMeta('name', 'twitter:title', title);
    setMeta('name', 'twitter:description', description);
    if (image) setMeta('name', 'twitter:image', image);
    setCanonical(canonical || href);
    setJsonLd(ld);
    return () => setJsonLd('');
  }, [title, description, keywords, image, canonical, url, type, ld]);
}
